import { Button, Callout, Modal } from '@hub/shared'
import { useTranslation } from 'react-i18next'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  errors: any
  openModal: boolean
  setOpenModal: (event: any) => any
}

export default ({ errors, openModal, setOpenModal }: Props) => {
  const [t] = useTranslation('modalPaymentErrors')

  const handledError = (error: string) => {
    if (t(`errors.${error}`).includes('DBA_')) {
      return false
    }

    return true
  }

  return (
    <Modal
      className="modal-payment-errors"
      open={openModal}
      modalSize="md"
      forceMobileNoMargin
      onCloseChange={() => setOpenModal(false)}
      buttonClose={false}
      header={
        <h5 style={{ margin: 0 }}>
          <i className="fa-solid fa-triangle-exclamation yellow mr-2"></i>
          {t('title')}
        </h5>
      }
      footer={
        <div className="display-flex justify-content-end">
          <Button
            onClick={() => setOpenModal(false)}
            id="confirm-button-modal-payment-errors"
            className="confirm-button-modal-payment-errors"
            size="sm"
          >
            <span style={{ whiteSpace: 'nowrap', display: 'inline-block', width: '100%' }}>{t('close')}</span>
          </Button>
        </div>
      }
    >
      <Callout icon="fa-solid fa-triangle-exclamation" colorIcon="var(--red)" title={t('subTitle')}>
        <ul style={{ paddingLeft: '1rem' }}>
          {errors?.map((error: any, index: number) =>
            handledError(error) ? (
              <li key={index}>
                <span>{t(`errors.${error}`)}</span>
              </li>
            ) : (
              <li key={index}>
                <span>
                  {t('unexpectedError')}: ({error})
                </span>
              </li>
            )
          )}
        </ul>
      </Callout>
    </Modal>
  )
}
